import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';
import styled from 'styled-components';
import { get, debounce } from 'lodash';
import { Icon } from 'semantic-ui-react';
import { updateLastViewedEssentialPage, updateUserPermission } from '../actions';
import { isMobileAgent, HHAlert } from '../common/util';
import { ALERT_TYPE } from '../common/constant';
import SelectLanguageDropdown from './selectLanguageDropdown';
import Notification from './notification';
import UserAvatarDropdown from './userAvatarDropdown';
import { Button } from '../../uiStandard/event/button';


const initialState = {
  isLoading: false, results: [], value: '', navColor: false, navMenuOpen: false
};

class Navbar extends Component {
  state = initialState;


  componentDidMount() {
    const { path } = this.props.match;
    const isHomePage = path === '/';
    if (isHomePage) {
      window.addEventListener('scroll', debounce(() => {
        this.changeBackground();
      }), 1000);
    }
  }

  componentWillUnmount() {
    const { path } = this.props.match;
    const isHomePage = path === '/';
    if (isHomePage) {
      window.removeEventListener('scroll', debounce(() => {
        this.changeBackground();
      }), 1000);
    }
  }

  changeBackground = () => {
    if (window.innerWidth >= 768 && window.scrollY >= 56 && this.state.navColor) return;
    if (window.innerWidth < 768 && window.scrollY >= 69 && this.state.navColor) return;

    if (window.innerWidth >= 768) {
      if (window.scrollY >= 56) {
        this.setState({
          ...this.state,
          navColor: true
        });
      } else {
        this.setState({
          ...this.state,
          navColor: false
        });
      }
    }
    if (window.innerWidth < 768) {
      if (window.scrollY >= 69) {
        this.setState({
          ...this.state,
          navColor: true
        });
      } else {
        this.setState({
          ...this.state,
          navColor: false
        });
      }
    }
  }


  render() {
    const { user, translate } = this.props;
    const { path } = this.props.match;
    const isHomePage = path === '/';
    const isMobile = isMobileAgent();

    const handleSignup = () => {
      this.props.updateLastViewedEssentialPage(window.location.pathname);
      this.props.history.push('/signup');
    };
    const handleLogin = () => {
      this.props.updateLastViewedEssentialPage(window.location.pathname);
      this.props.history.push('/login');
    };


    const handleOnClick = () => {
      if (isMobile) {
        HHAlert({ id: 'mobileAgent' }, ALERT_TYPE.ERROR);
      } else {
        this.props.updateUserPermission(() => { this.props.history.push('/admin/create-event'); });
      }
    };

    const isOrganizer = get(user, 'profile.basicInfo.signUpRole') === 'Organizer' ||
    get(user, 'profile.basicInfo.signupRole') === 'Organizer';

    return (
      <Header
        className='globalHeader'
        active={this.state.navColor}
        isHomePage={isHomePage ? !this.state.navColor : false}
      >
        <Link to='/' className='globalHeader_logo'>
          <picture>
            {
              isHomePage ? (
                <Fragment>
                  <source
                    srcSet={
                      this.state.navColor ? '/img/cms/logo-blue.png' : '/img/cms/create-event-logo.png'
                    } media='(min-width: 680px)'
                  />
                  <img
                    className={this.state.navColor ? 'blue-logo' : undefined}
                    src={
                      this.state.navColor ? '/img/general/logo-new-blue.png' : '/img/general/logo.png'
                    } alt='HackHub' title='HackHub'
                  />
                </Fragment>
              ) : (
                <Fragment>
                  <source
                    srcSet='/img/cms/logo-blue.png'
                    media='(min-width: 680px)'
                  />
                  <img
                    className='blue-logo'
                    src='/img/general/logo-new-blue.png'
                    alt='HackHub' title='HackHub'
                  />
                </Fragment>
              )
            }
          </picture>
        </Link>
        <HeaderList className='globalHeader_list'>
          {
            user.isLoggedIn ? (
              <Fragment>
                {
                  isOrganizer && (
                  <li className='globalHeader_list_item' data-item='create'>
                    <NavButton
                      isPrimary={false}
                      isSmall
                      label={translate('event.header.create')}
                      onClick={handleOnClick}
                      isHomePage={isHomePage ? !this.state.navColor : false}
                    />
                  </li>
                  )
                }
                <Notification navColor={this.state.navColor} />
                <UserAvatarDropdown navColor={this.state.navColor} />
              </Fragment>
            ) : (
              <Fragment>
                <li className='globalHeader_list_item' data-item='login'>
                  <LoginBtn
                    isPrimary={false} isSmall
                    label={translate('site.navbar.login')}
                    onClick={handleLogin}
                    isHomePage={isHomePage ? !this.state.navColor : false}
                  />
                </li>
                <li className='globalHeader_list_item' data-item='signup'>
                  <NavButton
                    isPrimary={false} isSmall
                    label={translate('site.navbar.signup')}
                    onClick={handleSignup}
                    isHomePage={isHomePage ? !this.state.navColor : false}
                  />
                </li>
              </Fragment>
              )
            }
          <SelectLanguageDropdown navColor={this.state.navColor} />
        </HeaderList>
        <MobileNavContainer isHomePage={isHomePage ? !this.state.navColor : false}>
          {
            this.state.navMenuOpen ? (
              <Icon
                name='close' size='large' onClick={() => this.setState({ navMenuOpen: !this.state.navMenuOpen })}
              />
            ) : (
              <Hamburger
                isHomePage={isHomePage ? !this.state.navColor : false}
                onClick={() => this.setState({ navMenuOpen: !this.state.navMenuOpen })}
              >
                <div />
                <div />
                <div />
              </Hamburger>
            )
          }
        </MobileNavContainer>
        <MobileNavMenu isOpen={this.state.navMenuOpen}>
          <SelectLanguageDropdown navColor={this.state.navColor} />
          {
            user.isLoggedIn ? (
              <Fragment>
                {
                  isOrganizer && (
                  <StyledList>
                    <MobileNavButton
                      isPrimary={false}
                      isSmall
                      label={translate('event.header.create')}
                      onClick={handleOnClick}
                      isHomePage={false}
                    />
                  </StyledList>
                  )
                }
                <Notification navColor={this.state.navColor} />
                <UserAvatarDropdown navColor={this.state.navColor} />
              </Fragment>
            ) : (
              <Fragment>
                <StyledList>
                  <MobileNavButton
                    isPrimary={false} isSmall
                    label={translate('site.navbar.signup')}
                    onClick={handleSignup}
                    isHomePage={false}
                  />
                </StyledList>
                <StyledList>
                  <LoginBtn
                    isPrimary={false} isSmall
                    label={translate('site.navbar.login')}
                    onClick={handleLogin}
                    isHomePage={false}
                  />
                </StyledList>
              </Fragment>
            )
          }
        </MobileNavMenu>
      </Header>
    );
  }
}

const Header = styled.header`
  background: ${props => (props.isHomePage ? 'transparent' : '#fff')};
  box-shadow: none;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  @media only screen and (max-width: 768px) {
    justify-content:space-between;
  }

  .globalHeader_logo {
    width: 137px;
  }

  .blue-logo {
    width: 136px;
    height: auto;
  }

  @media (max-width:680px) {
  .globalHeader_logo {
    width: 34px;
  }
  .blue-logo {
    width: 1.25rem;
  }
}
`;

const HeaderList = styled.ul`
  padding-right: 1em;
  background: transparent;
  margin-left: 1.4rem;
  @media only screen and (max-width: 768px) {
    display: none; 
  }
`;


const MobileNavContainer = styled.div`
  position :relative;
  display: none;
  @media only screen and (max-width: 768px) {
    display: block; 
  }

  i {
  color: ${props => (props.isHomePage ? '#fff' : '#0094FB')};
  cursor: pointer;
  }
`;

const MobileNavMenu = styled.ul`
  width: 100%;
  background: #fff;
  position: absolute;
  top: 73px;
  left: 0;
  text-align:center;
  padding: 2em 0;
  display: none;
  border: 1px solid #E7EDF5;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.02);
  @media only screen and (max-width: 768px) {
    display: ${(props) => (props.isOpen ? 'block' : 'none')}; 
  }
`;

export const StyledList = styled.li`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #666666;
  padding: 0.8em 0;

  :hover {
    color: #0095FA;
  }

  button {
    width: 50%;
  }

  @media only screen and (max-width: 387px) {
    li {
      font-size: 14px;
    }
  }
`;

const Hamburger = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  flex-direction: column;
  justify-content:space-around;
  align-items:center;
  cursor: pointer;
  margin-right: 0.8em;
  
  div {
    width: 100%;
    height: 3px;
    background: ${props => (props.isHomePage ? '#fff' : '#0094FB')};
    padding: 0.1rem 0;
  }
`;

export const NavButton = styled(Button)`
  border: ${props => (props.isHomePage ? '1px solid #fff' : '1px solid #0094FB')};
  color: ${props => (props.isHomePage ? '#fff' : '#0094FB')};
    :hover {
      color: #fff;
    }

  @media only screen and (max-width: 387px) {
    font-size: 14px;
  }
`;

const MobileNavButton = styled(NavButton)`
  background: #0094FB;
  color: #fff;
`;

const LoginBtn = styled(Button)`
  border: 1px solid transparent;
  color: ${props => (props.isHomePage ? '#fff' : '#0094FB')};

  :hover {
    color: #fff;
  }

  @media only screen and (max-width: 387px) {
    font-size: 14px;
  }
`;


export default compose(
  withLocalize,
  withRouter,
  connect(
    ({ user }) => ({ user }),
    { updateLastViewedEssentialPage, updateUserPermission }
  )
)(Navbar);



// WEBPACK FOOTER //
// ./src/components/nav/index.js